import * as Scrivito from "scrivito";
import contentPageObjIcon from "assets/images/landing_page_obj.svg";
import {
  defaultPageEditingConfigAttributes,
  defaultPropertiesGroups,
  defaultPageInitialContent,
  defaultPageProperties,
  defaultPageValidations,
} from "objs/_defaultPageEditingConfig";
import {
  metadataEditingConfigAttributes,
  metadataInitialContent,
  metadataPropertiesGroups,
  metadataValidations,
} from "objs/_metadataEditingConfig";

Scrivito.provideEditingConfig("ContentPage", {
  title: "Content Page",
  thumbnail: contentPageObjIcon,
  attributes: {
    ...defaultPageEditingConfigAttributes,
    ...metadataEditingConfigAttributes,
  },
  initialContent: {
    requiresTroxnetLogin: "No",
    requiresTroxnetLoginSeminare: "No",
    darkBg: "No",
    largePaddingsY: "No",
    breadCrumbs: "Yes",
    ...defaultPageInitialContent,
    ...metadataInitialContent,
  },
  properties: [...defaultPageProperties, "slides", "body"],
  propertiesGroups: [
    ...defaultPropertiesGroups,
    {
      title: "Advanced",
      properties: [
        "hidden_in_navigation",
        "keywords",
        "metaDescription",
        "navigationTitle",
        "navigationImage",
        "seoFooterText",
        "requiresTroxnetLogin",
        "backgroundImage",
        "darkBg",
        "largePaddingsY",
        "breadCrumbs",
      ],
    },
    ...metadataPropertiesGroups,
  ],
  validations: [...defaultPageValidations, ...metadataValidations],
});
